import { Box, Typography, Stack, IconButton, Avatar } from "@mui/joy";
import { useNavigate } from "react-router-dom";
import { useChatConversationByIdQuery } from "../../../__generated__/types-and-hooks";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import UserAvatar from "../../../components/UserAvatar";
import { Fragment } from "react/jsx-runtime";

export interface ChatHeaderProps {
  conversationId: number;
}

export default function ChatHeader({ conversationId }: ChatHeaderProps) {
  const navigate = useNavigate();
  const chatConversationQuery = useChatConversationByIdQuery({
    variables: { id: conversationId },
  });
  const convo = chatConversationQuery.data?.chat_conversation_by_id;

  return (
    <Stack direction="row">
      <IconButton
        sx={{ m: 1 }}
        variant="soft"
        onClick={() => navigate("/messages")}
      >
        <ArrowBackIosIcon />
      </IconButton>
      {convo && (
        <Stack direction="row" gap={2} p={1} alignItems="center">
          {convo.users.map((user) => (
            <Fragment key={user.id}>
              <Box>
                <UserAvatar userId={user.id} size="sm" />
              </Box>
              <Typography level="title-md">
                {(user.firstName ?? user.slug) + " " + user?.lastName}
              </Typography>
            </Fragment>
          ))}
          {convo.teams.map((team) => (
            <Fragment key={team.id}>
              <Box>
                <Avatar
                  size="sm"
                  sx={{
                    height: 36,
                    // width: "100%",
                    minWidth: 36,
                    width: 36,
                    borderRadius: 4,
                  }}
                  src={team.picture ?? "/images/qcsku_dark.jpg"}
                />
              </Box>
              <Typography level="title-md">{team.name}</Typography>
            </Fragment>
          ))}
        </Stack>
      )}
    </Stack>
  );
}
